import { REGION } from '../../app.constants';

/**
 * Helper to determine which validation logic to use based on region
 * Regions: EU, JP, AP
 */
export class CardHolderNameRegionHelper {
    /**
     * Asia regions (JP, AP) use new enhanced validation
     * EU region uses legacy validation
     */
    public static isAsiaRegion(region?: string): boolean {
        if (!region) {
            return false;
        }

        return region === REGION.JP || region === REGION.AP;
    }

    /**
     * Check if region uses legacy (EU) validation
     */
    public static isLegacyRegion(region?: string): boolean {
        if (!region) {
            return true; // Default to legacy for safety
        }

        return region === REGION.EU;
    }
}
